import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const SearchBox = styled.div`
	display: flex;
	margin-right: 100px;
	Button {
		height: 100%;
		display: ${props => props.showButton ? 'block' : 'none'};
	}
`;

export const SearchInput = styled.div`
	display: flex;
	align-items: center;
	border-radius: 8px;
	margin-left: 25px;
	background-color: ${Variables.colors.complementary_300};
	color: ${Variables.colors.complementary_900};
	padding: 0 15px;
	i {
		display: inline-block;
		padding: 8.5px;
		color: #757575;
		&:before {
			margin: 0;
		}
	}
	input {		
		width: 318px;
		background-color: inherit;
		color: inherit;
		border: none;
		outline: none;
	}
`;